import React, { Component } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import Routes from './routes';

import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { vi } from 'date-fns/locale/vi';
import 'react-datepicker/dist/react-datepicker.css';

import { i18n } from 'element-react';
import locale from 'element-react/src/locale/lang/vi';
import 'element-theme-default';

import './styles/business-hours-day.css';
import './styles/business-hours.css';
import './styles/toggle-switch.css';

import dayjs from 'dayjs';
import 'dayjs/locale/vi';
dayjs.locale('vi');

registerLocale('vi', vi);
setDefaultLocale('vi');

import jQuery from 'jquery';
window.$ = jQuery;
i18n.use(locale);
class App extends Component {
  render() {
    return (
      <Router
        forceRefresh={false}
        basename="/">
        <div className="body">
          <Routes/>
        </div>
      </Router>
    );
  }
}

export default App;
